import { useEffect } from "react";

const SITE_NAME = "Famibelleza";

export function usePageTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${SITE_NAME} | ${title}` : SITE_NAME;
  }, [title]);
}